import React, { useMemo } from "react";
import { CourseWareTypeList } from "../../../../../API/courseware";

const icons = {
    ppt: require("./img/ppt.png"),
    word: require("./img/word.png"),
    excel: require("./img/excel.png"),
    pdf: require("./img/pdf.png"),
    video: require("./img/video.png"),
    pic: require("./img/pic.png"),
    href: require("./img/href.png"),
    file: require("./img/file.png")
};

interface FileIconProps {
    ext: string;
    className?: string;
}

export default function FileIcon({ ext, ...RestProps }: FileIconProps) {
    const extName = useMemo<keyof typeof icons>(
        () => ext.toLocaleLowerCase() as any,
        [ext]
    );

    if (CourseWareTypeList.ppt.includes(extName))
        return <img src={icons.ppt} alt="ppt" {...RestProps} />;
    if (CourseWareTypeList.word.includes(extName))
        return <img src={icons.word} alt="word" {...RestProps} />;
    if (CourseWareTypeList.excel.includes(extName))
        return <img src={icons.excel} alt="excel" {...RestProps} />;
    if (CourseWareTypeList.pdf.includes(extName))
        return <img src={icons.pdf} alt="pdf" {...RestProps} />;
    if (CourseWareTypeList.video.includes(extName))
        return <img src={icons.video} alt="video" {...RestProps} />;
    if (CourseWareTypeList.pic.includes(extName))
        return <img src={icons.pic} alt="pic" {...RestProps} />;
    if (CourseWareTypeList.href.includes(extName))
        return <img src={icons.href} alt="href" {...RestProps} />;

    return <img src={icons.file} alt="file" {...RestProps} />;
}
